/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Min_Event_DurationInputs */

const en_min_event_duration = /** @type {(inputs: Min_Event_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimum Event Duration (sec)`)
};

const fr_min_event_duration = /** @type {(inputs: Min_Event_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durée minimale d’un événement (s)`)
};

const de_min_event_duration = /** @type {(inputs: Min_Event_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mindestdauer des Ereignisses (Sek.)`)
};

const it_min_event_duration = /** @type {(inputs: Min_Event_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durata minima dell'evento (sec)`)
};

const ru_min_event_duration = /** @type {(inputs: Min_Event_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Минимальная продолжительность события (сек)`)
};

const es_min_event_duration = /** @type {(inputs: Min_Event_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duración mínima del evento (seg.)`)
};

const zh_cn2_min_event_duration = /** @type {(inputs: Min_Event_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最短事件持续时间（秒）`)
};

const ja_min_event_duration = /** @type {(inputs: Min_Event_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最小イベント継続時間（秒）`)
};

const hi_min_event_duration = /** @type {(inputs: Min_Event_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`न्यूनतम आयोजन अवधि (सेकंड)`)
};

const pt_pt2_min_event_duration = /** @type {(inputs: Min_Event_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duração mínima do evento (segundos)`)
};

/**
* | output |
* | --- |
* | "Minimum Event Duration (sec)" |
*
* @param {Min_Event_DurationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const min_event_duration = /** @type {((inputs?: Min_Event_DurationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Min_Event_DurationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_min_event_duration(inputs)
	if (locale === "de") return de_min_event_duration(inputs)
	if (locale === "it") return it_min_event_duration(inputs)
	if (locale === "ru") return ru_min_event_duration(inputs)
	if (locale === "es") return es_min_event_duration(inputs)
	if (locale === "zh-CN") return zh_cn2_min_event_duration(inputs)
	if (locale === "ja") return ja_min_event_duration(inputs)
	if (locale === "hi") return hi_min_event_duration(inputs)
	if (locale === "pt-PT") return pt_pt2_min_event_duration(inputs)
	return en_min_event_duration(inputs)
});